import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  width: 728px;
  height: 90px;

  img {
    width: 728px;
    height: 90px;
  }
`;

type Props = {
  media: {
    type: string;
    url: string;
  };
};

const BottomBannerSlot: React.FC<Props> = ({ media }) => {
  return (
    <Container>
      <img src={media.url} />
    </Container>
  );
};

export default BottomBannerSlot;
